import { ComponentProps, CSSProperties } from 'react';
import { Pill as PillComponennt, PillSize } from '@tag/tag-components-react-v4';

export {
  PillSize
};

interface IPillProps extends ComponentProps<typeof PillComponennt> {
  background?: string;
}

export const Pill = (props: IPillProps) => {
  const { children, background, style, ...restProps } = props;

  const defaultStyles: CSSProperties = {
    fontSize: 13,
    background,
    borderColor: background,
  };

  return (
        <PillComponennt
            {...restProps}
            style={{
              ...defaultStyles,
              ...style
            }}
        >
            {children}
        </PillComponennt>
  );
};

